import { Injectable } from '@angular/core';

import type { FtpConnectionConfig, FtpFileEntry, FtpTransport } from './ftp-transport.port';

const NOT_IMPLEMENTED = 'FtpTransport is a stub — the real FTP plugin adapter is not wired yet';

@Injectable()
export class FtpTransportStub implements FtpTransport {
  connect(_config: FtpConnectionConfig): Promise<void> {
    throw new Error(NOT_IMPLEMENTED);
  }

  disconnect(): Promise<void> {
    throw new Error(NOT_IMPLEMENTED);
  }

  list(_remoteDir: string): Promise<Array<FtpFileEntry>> {
    throw new Error(NOT_IMPLEMENTED);
  }

  size(_remotePath: string): Promise<number> {
    throw new Error(NOT_IMPLEMENTED);
  }

  downloadToFile(_remotePath: string, _localPath: string): Promise<void> {
    throw new Error(NOT_IMPLEMENTED);
  }
}
